import { MatchesQueryParams, useMatchesQuery } from './useMatchesQuery';

export const useTodaysMatchesQuery = (params?: MatchesQueryParams) => {
  const today = new Date();
  return useMatchesQuery({
    // @ts-expect-error - Some import recursion happening with @repo/types
    period: 'Custom',
    startDate: `${today.toISOString().substring(0, 10)}T00:00:00`,
    endDate: `${today.toISOString().substring(0, 10)}T23:59:59`,
    limit: 300,
    ...(params ?? {}),
  });
};
